import Card from './TeamCard'
import Modal from './TeamModal'
import Graph from './TeamGraph'

export default {
    Card,
    Modal,
    Graph
}